import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import Prism from 'prismjs';
import 'prismjs/components/prism-python';

@Component({
  selector: 'app-code-display',
  templateUrl: './code-display.component.html',
  styleUrl: './code-display.component.scss',
  standalone: false,
})
export class CodeDisplayComponent implements OnChanges {
  isCodeVisible = false;
  @Input() label?: string = '';
  @Input() pythonCode?: string = '';

  highlightedCode: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['pythonCode'] &&
      changes['pythonCode'].currentValue !== undefined
    ) {
      this.updateHighlightedCode();
    }
  }

  private updateHighlightedCode() {
    if (this.pythonCode)
      this.highlightedCode = Prism.highlight(
        this.pythonCode,
        Prism.languages['python'],
        'python',
      );
  }

  toggleCode(): void {
    this.isCodeVisible = !this.isCodeVisible;
  }
}
